//import './vendor.js';
import './../sass/style.scss';
import 'bootstrap';
import fontawesome from '@fortawesome/fontawesome';
import light from '@fortawesome/fontawesome-pro-light';
import brands from '@fortawesome/fontawesome-free-brands';
import Flickity from 'flickity';
import 'lightgallery/dist/js/lightgallery-all';

import noUiSlider from 'nouislider';

//import wNumb from './wnumb-1.1.0/wNumb';

//import 'lazysizes/lazysizes.min.js';

import 'isotope-layout/dist/isotope.pkgd.js';
import 'imagesloaded/imagesloaded.pkgd.js';

fontawesome.library.add(light);

jQuery(function ($) {
	"use strict";

	var $ = jQuery;

	function myAddParameterAndReturn(url, paramName, paramValue)
	{
	    if (url.indexOf(paramName + "=") >= 0)
	    {
	        var prefix = url.substring(0, url.indexOf(paramName));
	        var suffix = url.substring(url.indexOf(paramName));
	        suffix = suffix.substring(suffix.indexOf("=") + 1);
	        suffix = (suffix.indexOf("&") >= 0) ? suffix.substring(suffix.indexOf("&")) : "";
	        url = prefix + paramName + "=" + paramValue + suffix;
	    }
	    else
	    {
	    if (url.indexOf("?") < 0)
	        url += "?" + paramName + "=" + paramValue;
	    else
	        url += "&" + paramName + "=" + paramValue;
	    }
	    return url;
	}

	var geoMarkers = [];
	var googleMapMarkers = [];

	function requestMarkers(map, url, oms){
	    deleteMarkers();
	    $.ajax({
	      dataType: "json",
	      url: url,
	    }).done(function(json) {
	      $.each(json, function(index, elem){
	       // console.log(elem);
	        geoMarkers.push({
	             "type": "Feature",
	             "geometry": {
	                 "type": "Point",
	                 "coordinates": [
	                     elem.address.lng,
	                     elem.address.lat
	                 ]
	             },
	             "properties": {
	                 "postid" : elem.post.ID,
	                 "link": elem.permalink,
	                 "marker": elem.markerIcon
	             }
	         });
	      });
	      oms.removeAllMarkers();
	      setMarkers(map, geoMarkers, oms);
	    })
	}

	function setMarkers(map, geoMarkers, oms){
	    var geojson =
	    {
	        "type": "FeatureCollection",
	        "features": geoMarkers
	        
	    };

	    
	    //console.log(geojson);
	    if (geojson.features.length >= 1) {
	        var bounds = new google.maps.LatLngBounds();	        
	        geojson.features.forEach(function(feature) {
	          if (feature.geometry.coordinates[1] && feature.geometry.coordinates[0]) {
	            var icon = new google.maps.MarkerImage(
	                        feature.properties.marker,
	                        new google.maps.Size(34,44),
	                        null,
	                        null,
	                        new google.maps.Size(34,44)
	                    );
	            
	            var markerpos = new google.maps.LatLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
	            var marker = new google.maps.Marker({
	              position: markerpos,
	              map: map,
	              title: '',
	              animation: google.maps.Animation.DROP,
	              url: feature.properties.link,
	              icon: icon
	            });


	            oms.addMarker(marker);
	            //googleMapMarkers.push(marker);
	          //  console.log(feature)
	            google.maps.event.addListener(marker, 'spider_click', function() {
	                window.open(this.url);
	            });
	            bounds.extend(markerpos);
	            }
	        });
	        google.maps.event.trigger(map, "resize");
	        $('.loadingOverlay').hide();
	        if (geoMarkers.length > 1) {
	          map.fitBounds(bounds);
	          setTimeout(function(){
	          	map.setZoom(map.getZoom() - 1);
	          }, 100)
	          
	        } else {
	          map.fitBounds(bounds);
	          map.setZoom(12);
	        }
	    };
	}

	function deleteMarkers() {
	    for (var i = 0; i < googleMapMarkers.length; i++) {
	        googleMapMarkers[i].setMap(null);
	    }
	    googleMapMarkers = [];
	    geoMarkers  = [];
	}

	function preventDefault(e) {
	  e = e || window.event;
	  if (e.preventDefault)
	      e.preventDefault();
	  e.returnValue = false;  
	}

	function keydown(e) {
	    for (var i = keys.length; i--;) {
	        if (e.keyCode === keys[i]) {
	            preventDefault(e);
	            return;
	        }
	    }
	}

	function wheel(e) {
	  preventDefault(e);
	}

	function disable_scroll() {
	  if (window.addEventListener) {
	      window.addEventListener('DOMMouseScroll', wheel, false);
	  }
	  window.onmousewheel = document.onmousewheel = wheel;
	  document.onkeydown = keydown;
	}

	function enable_scroll() {
	    if (window.removeEventListener) {
	        window.removeEventListener('DOMMouseScroll', wheel, false);
	    }
	    window.onmousewheel = document.onmousewheel = document.onkeydown = null;  
	}

	

	function isScrolledIntoView(elem) {
	    var docViewTop = $(window).scrollTop();
	    var docViewBottom = docViewTop + $(document).height();

	    var elemTop = $(elem).offset().top;
	    var elemBottom = elemTop + $(elem).height();

	    return ((elemTop <= (docViewTop + $(document).height())));
	}
	function revealElements() {
		$('.reveal').each(function () {
		var $revealElement = $(this);
		if (isScrolledIntoView($revealElement) === true) {
	   		if ($revealElement.data('delay')) {
	        	setTimeout(function(){
	            	$($revealElement).addClass('revealed');
	       		}, $revealElement.data('delay'));
	        } else {
                setTimeout(function(){
                    $($revealElement).addClass('revealed');
                }, 0);
            }
	        }
	    });
	}
	$(document).ready(function(){

		revealElements();
		$(window).on('scroll', function(){
		    revealElements();
		});

		$('.member').on('click', function(){
			$(this).trigger('hover');
		});

		$('.navbar-collapse a').on('click', function(){
			$('.navbar-toggler').trigger('click');
		});

		if ($('.vhfull').length) {
			$('.vhfull').each(function(index, vl){
				var vhfullHeightPadding = $(vl).outerHeight() - $(vl).height();
				$(vl).css('min-height', $(vl).find('.container').outerHeight() + vhfullHeightPadding);
			});
		}

		$(window).on('resize', function(){
			if ($('.vhfull').length) {
				$('.vhfull').each(function(index, vl){
					var vhfullHeightPadding = $(vl).outerHeight() - $(vl).height();
					$(vl).css('min-height', $(vl).find('.container').outerHeight() + vhfullHeightPadding);
				});
			}
		});
		
		$('.fullbg').css('opacity', '1');

		if ($('.homeSlider').length) {
			var flky = new Flickity( '.homeSlider', {
				cellAlign: 'left',
				wrapAround: true,
				autoPlay: 4000,
				imagesLoaded: true,
				prevNextButtons: true,
				pageDots: false,
				draggable: true,
				arrowShape: { 
				  x0: 10,
				  x1: 55, y1: 45,
				  x2: 60, y2: 45,
				  x3: 15
				}
			});
			window.addEventListener( 'load', function() {
			  flky.resize();
			});			
		}

		if ($('.slider').length) {
			var flky = new Flickity( '.slider', {
				cellAlign: 'left',
				wrapAround: true,
				autoPlay: 7000,
				imagesLoaded: true,
				prevNextButtons: false,
				pageDots: false,
				draggable: false
			});
			window.addEventListener( 'load', function() {
			  flky.resize();
			});			
		}



		$('.gallery').lightGallery({
			selector: '.gallery-item a'
		});

		$('.casawp-main-flickity').lightGallery({
			selector: '.property-image-gallery',
			download: false,
			thumbnail: false
		});

		if ($('.casawp-main-flickity').length) {
			var immoSlider = new Flickity('.casawp-main-flickity', {
				cellAlign: 'center',
				draggable: false,
				wrapAround: true,
				pageDots: false,
				freeScroll: true,
				imagesLoaded: true,
				prevNextButtons: true,
				autoPlay: 7000,
				arrowShape: { 
				  x0: 10,
				  x1: 55, y1: 45,
				  x2: 60, y2: 45,
				  x3: 15
				}
			});

			window.addEventListener( 'load', function() {
			  immoSlider.resize();
			});
		}

		if ($('.archiSlider').length) {
			var flickities = [];
			var galleryElems = document.querySelectorAll('.archiSlider');
			for ( var i=0, len = galleryElems.length; i < len; i++ ) {
			  var galleryElem = galleryElems[i];
			  var flkty = new Flickity( galleryElem, {
			    cellSelector: '.flickity-item',
			    cellAlign: 'center',
			    draggable: true,
			    wrapAround: true,
			    pageDots: false,
			    freeScroll: true,
			    imagesLoaded: true,
			    prevNextButtons: true,
			    autoPlay: 7000,
			    arrowShape: { 
			      x0: 10,
			      x1: 55, y1: 45,
			      x2: 60, y2: 45,
			      x3: 15
			    }
			  });
			  flickities.push( flkty );
			}

			window.addEventListener( 'load', function() {
				flickities.forEach( function( flkty ) {
				  flkty.resize();
				});
			});
		}

		if ($('.toNext').length) {
			$('.toNext').each(function(index, il){
				$(il).attr('href', $(il).parent().next().find('.m-anchor').attr('id'));
			});
		}


		$('.toBottom').on('click', function(){
			disable_scroll();
			$('html, body').stop().animate({
				scrollTop: $('#content').offset().top - 135
			}, 700, function(){
				enable_scroll();
			});
			return false;
		});

		$('.toNext').on('click', function(){
			disable_scroll();
			$('html, body').stop().animate({
				scrollTop: $(this).parent().next().offset().top - 135
			}, 700, function(){
				enable_scroll();
			});
			return false;
		});

		$('.mobile-main-menu .menu-item-has-children ul a').on('click', function(){
			$('.mobile-main-menu .menu-item-has-children ul a').css('font-weight', 400);
			$(this).css('font-weight', 700);
		});


		$('.navbar-toggler').on('click', function(){
			if ($(this).hasClass('active-nav')) {
				$(this).removeClass('active-nav');
				$('.navbarOuter').removeClass('nav-bg');
			} else {
				$(this).addClass('active-nav');
				$('.navbarOuter').addClass('nav-bg');
			}
		});

		$('.navbar-collapse').on('shown.bs.collapse', function(){
			$('#footer').hide();
			$('#content').hide();
			$('.sliderOuter').hide();
			$('#header').css('position', 'absolute');
			$('.navbar-toggler').removeClass('dontClick');
		});

		$('.navbar-collapse').on('show.bs.collapse', function(){
			$('.navbar-toggler').addClass('dontClick');
		});

		$('.navbar-collapse').on('hidden.bs.collapse', function(){
			$('.navbar-toggler').removeClass('dontClick');
		});

		$('.navbar-collapse').on('hide.bs.collapse', function(){
			$('#header').css('position', 'fixed');
			$('#footer').show();
			$('#content').show();
			$('.sliderOuter').show();
			$('.navbar-toggler').addClass('dontClick');
		});



		var $grid = $('.grid').isotope({
	 	    itemSelector: '.grid-item'
	  	});


	  	$grid.imagesLoaded().progress( function() {
	  	  $grid.isotope('layout');
	  	});


		if ($('.contentSlider').length) {
			var flky = new Flickity( '.contentSlider', {
				cellAlign: 'left',
				contain: true,
				imagesLoaded: true,
				prevNextButtons: true,
				pageDots: false,
				draggable: false,
				arrowShape: 'M7.9948243,51 L25.6594402,67.871693 C26.0588254,68.2531507 26.0733584,68.8861488 25.6919008,69.285534 C25.3104431,69.6849191 24.6774449,69.6994522 24.2780598,69.3179945 L4.80930978,50.7231508 C4.39689674,50.32925 4.39689674,49.67075 4.80930978,49.2768492 L24.2780598,30.6820055 C24.6774449,30.3005478 25.3104431,30.3150809 25.6919008,30.714466 C26.0733584,31.1138512 26.0588254,31.7468493 25.6594402,32.128307 L7.9948243,49 L95,49 C95.5522847,49 96,49.4477153 96,50 C96,50.5522847 95.5522847,51 95,51 L7.9948243,51 Z'
			});
			window.addEventListener( 'load', function() {
			  flky.resize();
			});
		}

		if ($('.bigSlider').length) {
			var big = new Flickity( '.bigSlider', {
				cellAlign: 'left',
				contain: true,
				imagesLoaded: true,
				prevNextButtons: true,
				pageDots: false,
				draggable: false,
				arrowShape: 'M7.9948243,51 L25.6594402,67.871693 C26.0588254,68.2531507 26.0733584,68.8861488 25.6919008,69.285534 C25.3104431,69.6849191 24.6774449,69.6994522 24.2780598,69.3179945 L4.80930978,50.7231508 C4.39689674,50.32925 4.39689674,49.67075 4.80930978,49.2768492 L24.2780598,30.6820055 C24.6774449,30.3005478 25.3104431,30.3150809 25.6919008,30.714466 C26.0733584,31.1138512 26.0588254,31.7468493 25.6594402,32.128307 L7.9948243,49 L95,49 C95.5522847,49 96,49.4477153 96,50 C96,50.5522847 95.5522847,51 95,51 L7.9948243,51 Z'
			});
			window.addEventListener( 'load', function() {
			  big.resize();
			});
		}

		$('.form-group select').parent().append('<i class="fal fa-angle-down"></i>');

		if ($('.chosen-single').length) {
			$('.chosen-single').append('<i class="fal fa-angle-down"></i>');
		}

        rangeDropdownsToSlider();
		$('.casawp-filterform').on( "casawp-filterform:after-filter-reload", function(event, url, filteredUrl){
			rangeDropdownsToSlider();
		});

        function rangeDropdownsToSlider(){
			if($('.casawp-filterform-pricecount-2')){
				$('.casawp-filterform-pricecount-2').each(function(idx, priceWrapperElem){
					const $priceWrapperElem = $(priceWrapperElem);
					const $fromElem = $priceWrapperElem.find("select[name=price_from]");
					const $toElem = $priceWrapperElem.find("select[name=price_to]");
					if ($fromElem.length && $toElem.length) {
						let fromVal = $fromElem.find("option:first-child").val();
						if (!fromVal) {
							//the first item ist often a mask
							fromVal = $fromElem.find("option:nth-child(2)").val();
						}
						const toVal = $toElem.find("option:last-child").val();
						if (fromVal && toVal) {
							$fromElem.replaceWith('<input type="number" name="price_from" value="'+$fromElem.val()+'" />');
							$toElem.replaceWith('<input type="number" name="price_to" value="'+$toElem.val()+'" />');

							const values = $fromElem.find('option').map(function() { return ($(this).val() ? parseInt($(this).val()) : 0); }).get();
							let range = {};
							values.forEach((value, idx) => {
								if (idx === 0) {
									range.min = value;
								} else if((idx+1) === values.length){
									range.max = value;
								} else {
									range[(idx*(100/values.length))+"%"] = value;
								}
							});
							console.log(range);

							const $rFromElem = $priceWrapperElem.find("input[name=price_from]");
							const $rToElem = $priceWrapperElem.find("input[name=price_to]");

							$priceWrapperElem.find('.casawp-filterform-duo-item label, .casawp-filterform-duo-item div, .casawp-filterform-duo-item input').hide();
							$priceWrapperElem.find('.casawp-filterform-duo-label').show();

							const $rangeSliderControl = $('<div class="form-control form-control-slider"><div class="noUi-placeholder" /></div>');
							$priceWrapperElem.append($rangeSliderControl);

							const sliderElem = $rangeSliderControl.find('.noUi-placeholder')[0];


							noUiSlider.create(sliderElem, {
								start: [
									(parseInt($fromElem.val()) ? parseInt($fromElem.val()) : 0),
									(parseInt($toElem.val()) ? parseInt($toElem.val()) : toVal)
								],
								connect: true,
								snap: true,
								range: range,
								/*pips: {
									mode: 'positions',
									values: [0,50,100],
									density: 3,
									// filter: ( value, type ) => {
									// 	return value % 1000 ? 2 : 1;
									// },
									format: wNumb({
										decimals: 0,
										prefix: 'CHF ',
										thousand: '\'',
									}),
									stepped: true,
								}*/
								format: {
								    to: function ( value ) {
								    return Math.round(value);
								    },
								    from: function ( value ) {
								        return Math.round(value);
								    }
								}

							});

							var priceSliderValues = [
							    document.getElementById('price-slider-lower-value'),
							    document.getElementById('price-slider-upper-value')
							];

							priceSliderValues[0].innerHTML = $fromElem.val();
							priceSliderValues[1].innerHTML = $toElem.val();

							sliderElem.noUiSlider.on('update', function( values, handle ) {
							    priceSliderValues[handle].innerHTML = 'CHF ' + values[handle];
							});

							sliderElem.noUiSlider.on('change', ( values, handle ) => {
								var value = values[handle];

								if ( handle === 0 ) {
									$rFromElem.val(Math.round(parseInt(value)));
								} else {
									$rToElem.val(Math.round(parseInt(value)));
								}

								$('.casawp-filterform').trigger('change');
							});
						}
					}
				})
			}


			if($('.casawp-filterform-roomscount-2')){
				$('.casawp-filterform-roomscount-2').each(function(idx, roomsWrapperElem){
					const $roomsWrapperElem = $(roomsWrapperElem);
					const $fromElem = $roomsWrapperElem.find("select[name=rooms_from]");
					const $toElem = $roomsWrapperElem.find("select[name=rooms_to]");
					if ($fromElem.length && $toElem.length) {
						let fromVal = $fromElem.find("option:first-child").val();
						if (!fromVal) {
							//the first item ist often a mask
							fromVal = $fromElem.find("option:nth-child(2)").val();
						}
						const toVal = $toElem.find("option:last-child").val();
						if (fromVal && toVal) {
							$fromElem.replaceWith('<input type="number" name="rooms_from" value="'+$fromElem.val()+'" />');
							$toElem.replaceWith('<input type="number" name="rooms_to" value="'+$toElem.val()+'" />');

							const values = $fromElem.find('option').map(function() { return ($(this).val() ? parseInt($(this).val()) : 0); }).get();
							let range = {};
							values.forEach((value, idx) => {
								if (idx === 0) {
									range.min = value;
								} else if((idx+1) === values.length){
									range.max = value;
								} else {
									range[(idx*(100/values.length))+"%"] = value;
								}
							});
							console.log(range);

							const $rFromElem = $roomsWrapperElem.find("input[name=rooms_from]");
							const $rToElem = $roomsWrapperElem.find("input[name=rooms_to]");

							$roomsWrapperElem.find('.casawp-filterform-duo-item label, .casawp-filterform-duo-item div, .casawp-filterform-duo-item input').hide();
							$roomsWrapperElem.find('.casawp-filterform-duo-label').show();

							const $rangeSliderControl = $('<div class="form-control form-control-slider"><div class="noUi-placeholder" /></div>');
							$roomsWrapperElem.append($rangeSliderControl);

							const sliderElem = $rangeSliderControl.find('.noUi-placeholder')[0];


							noUiSlider.create(sliderElem, {
								start: [
									(parseInt($fromElem.val()) ? parseInt($fromElem.val()) : 0),
									(parseInt($toElem.val()) ? parseInt($toElem.val()) : toVal)
								],
								connect: true,
								snap: true,
								range: range,
								/*pips: {
									mode: 'positions',
									values: [0,50,100],
									density: 3,
									// filter: ( value, type ) => {
									// 	return value % 1000 ? 2 : 1;
									// },
									format: wNumb({
										decimals: 0,
										prefix: 'CHF ',
										thousand: '\'',
									}),
									stepped: true,
								}*/
								format: {
								    to: function ( value ) {
								    return Math.round(value);
								    },
								    from: function ( value ) {
								        return Math.round(value);
								    }
								}

							});

							var roomsSliderValues = [
							    document.getElementById('rooms-slider-lower-value'),
							    document.getElementById('rooms-slider-upper-value')
							];

							roomsSliderValues[0].innerHTML = $fromElem.val();
							roomsSliderValues[1].innerHTML = $toElem.val();

							sliderElem.noUiSlider.on('update', function( values, handle ) {
							    roomsSliderValues[handle].innerHTML = values[handle];
							});

							sliderElem.noUiSlider.on('change', ( values, handle ) => {
								var value = values[handle];

								if ( handle === 0 ) {
									$rFromElem.val(Math.round(parseInt(value)));
								} else {
									$rToElem.val(Math.round(parseInt(value)));
								}

								$('.casawp-filterform').trigger('change');
							});
						}
					}
				})
			}
		}
				

	});

	var url = window.location.origin;
	$('#architekturFilters').on('change', function(){
		$.ajax({
			url : url + '/wp-admin/admin-ajax.php',
			data : $('#architekturFilters').serialize(),
			dataType : 'json',
			type : 'POST',
			beforeSend : function ( xhr ) {
				$('#spinnerResults').removeClass('d-none');
			},
			success : function( data ){
				current_page_myajax = 1; 
				posts_myajax = data.posts;
				max_page_myajax = data.max_page; 
				$('#architekturResults').html(data.content); 
				if ($('.archiSlider').length) {
					var flickities = [];
					var galleryElems = document.querySelectorAll('.archiSlider');
					for ( var i=0, len = galleryElems.length; i < len; i++ ) {
					  var galleryElem = galleryElems[i];
					  var flkty = new Flickity( galleryElem, {
						cellSelector: '.flickity-item',
						cellAlign: 'center',
						draggable: true,
						wrapAround: true,
						pageDots: false,
						freeScroll: true,
						imagesLoaded: true,
						prevNextButtons: true,
						autoPlay: 7000,
						arrowShape: { 
						  x0: 10,
						  x1: 55, y1: 45,
						  x2: 60, y2: 45,
						  x3: 15
						}
					  });
					  flickities.push( flkty );
					}

					window.addEventListener( 'load', function() {
						flickities.forEach( function( flkty ) {
						  flkty.resize();
						});
					});
				}
				disable_scroll();
				$('html, body').stop().animate({
					scrollTop: $('#architekturFilters').offset().top - 135
				}, 700, function(){
					enable_scroll();
				});
				return false;
			},
			complete: function(){
				$('#spinnerResults').addClass('d-none');
			},
		});
		return false;
	});

});



// WEBPACK FOOTER //
// ./src/js/main.js